import React from "react";
import ReporteComisionesPagos from "../components/ReporteComisionesPagos";

const InformeComisionesPagos = () => {
  return (
    <>
      <ReporteComisionesPagos />
    </>
  );
};

export default InformeComisionesPagos;